import React from 'react';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,

  // useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface CustomDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  width?: number | string;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  children: React.ReactNode;
  subtitle?: string;
  actions?: React.ReactNode;
  zIndex?: number;
}

export const CustomDrawer: React.FC<CustomDrawerProps> = ({
  open,
  onClose,
  title,
  width = 500,
  anchor = 'right',
  children,
  subtitle,
  actions,
  zIndex,
}) => {
  // const theme = useTheme();

  // Default to a z-index above AppBar (1100) but below our dropdown z-index (1600)
  const drawerZIndex = zIndex ?? 1300;
   const theme = useTheme();
  const isMobile = useMediaQuery(theme?.breakpoints.down('sm'));
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile?'100%': width,
          p: 3,
          zIndex: drawerZIndex,
        },
      }}
      sx={{
        zIndex: drawerZIndex,
        '& .MuiDrawer-paper': {
          zIndex: drawerZIndex,
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        mb={3}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          pb: 2,
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            bgcolor: 'action.hover',
            ml: 2,
            '&:hover': { bgcolor: 'action.selected' },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ flexGrow: 1 }}>
        {children}
      </Box>

      {actions && (
        <Box
          sx={{
            borderTop: 1,
            borderColor: 'divider',
            pt: 2,
            mt: 3,
          }}
        >
          {actions}
        </Box>
      )}
    </Drawer>
  );
};